import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-excel';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksVeranstaltungExcelEffects {

    VeranstaltungExcel$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_EXCEL),
        mergeMap((x: ac.GetVeranstaltungExcelAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungExcel(x.veranstaltungUebersichtRequest).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungExcelErfolgreichAction(result, x.veranstaltungUebersichtRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungExcelFehlerAction(error, x.veranstaltungUebersichtRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
